import { validateFile } from '../custom/validateFile';

const FileDirective = () => ({
  require: 'ngModel',
  restrict: 'A',
  link: ($scope, el, attrs, ngModel) => {
    el.bind('change', (event) => {
      const [file] = event.target.files;
      if (!file) return;

      const { validationType } = attrs;
      if (validationType) {
        ngModel.$setViewValue(Object.assign(ngModel.$viewValue, { validating: true }));
        $scope.$apply();

        validateFile(file, validationType).then((validationErrors) => {
          ngModel.$setViewValue({ name: file.name, validationErrors, validating: false });
          $scope.$apply();
        });
      } else {
        ngModel.$setViewValue({ name: file.name, validationErrors: null, validating: false });
        $scope.$apply();
      }
    });
  },
});

export default FileDirective;
